import { ResponseType } from "../../Types/ServicesType/servicesType";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const { clinicId } = getConstants();
const { reportsApi } = api;

export const agingReportPdf = async (params: {
  clinicId: number;
  insuranceType: string | null;
  receiver: string | null;
  payer: string | null;
}) => {
  const result = await instance.post(reportsApi.agingReportPdf, {
    ...params,
    clinicId,
  });
  return result.data;
};

export const agingReportTable = async (params: {
  clinicId: number;
  insuranceType: string | null;
  receiver: string | null;
  payer: string | null;
}): Promise<
  ResponseType<
    {
      phnNo: string;
      Name: string;
      InsType: string;
      InsuranceName: string;
      InsuranceShare: number;
      SlNo: number;
      claimSubmitId: number;
      claim_id: number;
      days: number;
      claimSubmittedDate: string;
    }[]
  >
> => {
  const result = await instance.post(reportsApi.agingReportTableData, {
    ...params,
  });
  return result.data;
};
